import detailDefault from "../../detailDefault";

export default class detailUsers extends detailDefault {
    load(sAction, data) {
        if(sAction.userPreferences.is_admin == 1){
            sAction.dataSet(data.prefix+"/fields/calendar_users/def/readonly", false);
        }
        const category = sAction.dataGet(`${data.prefix}/fields/msgraph_callendar_category/value`);
        this.categoryFilterCheckbox(sAction, data.prefix, category);
    }
    update(sAction, data) {
        switch (data.field){
            case 'msgraph_meeting_is_draft_default':
                sAction.alert(sAction.translate('LBL_RELOAD_WHOLE_APP', 'Users'));
                break;
            case 'msgraph_callendar_sync_only_upcoming':
                if (data.value) { // if we are setting sync, we want actually start it!
                    const msgraphCallendarUp = sAction.dataGet(`${data.prefix}/fields/msgraph_callendar_up/value`);
                    if (!(+msgraphCallendarUp)) {
                        sAction.dsAdd('set', `${data.prefix}/fields/msgraph_callendar_up/value`, 1);
                        sAction.dsAdd('set', `${data.prefix}/changes/fields/msgraph_callendar_up`, 1);
                        sAction.dsProcess();
                    }
                }
                break;
            case 'msgraph_tasks_outlook_down':
            case 'msgraph_tasks_outlook_up':
            case 'msgraph_tasks_planner_down':
            case 'msgraph_tasks_planner_up':
                this.handleOffice365TaskSwitches(sAction, data);
                break;
            case 'msgraph_callendar_category':
                this.categoryFilterCheckbox(sAction, data.prefix, data.value);
                break;
        }
    }

    /**
     *
     * @param {sAction} sAction
     * @param {string} prefix
     * @param {string|null} category
     */
    categoryFilterCheckbox(sAction, prefix, category) {
        let readonly = true;
        if (category) {
            readonly = false;
        }

        sAction.dataSet(`${prefix}/fields/msgraph_callendar_category_as_filter/def/readonly`, readonly);
    }

    /**
     * User shouldn't synchronize tasks to Office Planner and to To-do (Outlook) at the same time. On collision, display popup
     *
     * @param {sAction} sAction
     * @param {{}} data
     */
    handleOffice365TaskSwitches(sAction, data) {
        const taskDown = !!parseInt(sAction.dataGet(`${data.prefix}/fields/msgraph_tasks_outlook_down/value`));
        const taskUp = !!parseInt(sAction.dataGet(`${data.prefix}/fields/msgraph_tasks_outlook_up/value`));
        const taskPlannerDown = !!parseInt(sAction.dataGet(`${data.prefix}/fields/msgraph_tasks_planner_down/value`));
        const taskPlannerUp = !!parseInt(sAction.dataGet(`${data.prefix}/fields/msgraph_tasks_planner_up/value`));
        if ((taskDown || taskUp) && (taskPlannerDown || taskPlannerUp)) {
            sAction.error(sAction.translate('LBL_MSGRAPH_TASK_PLANNNER_OUTLOOK_COLLISION', 'Users'));
            sAction.dataSet(`${data.prefix}/fields/${data.field}/value`, data.prevValue);
            sAction.dataSet(`${data.prefix}/changes/fields/${data.field}`, data.prevValue);
        }
    }
}
